import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer"; // This points to index.js

const store = configureStore({
  reducer: rootReducer,
});

export default store;
